<script lang="ts">
  interface Props {
    number: number;
  }
  let { number }: Props = $props();
</script>

<div class="countdown">
  {#key number}<div class="count-num">{number}</div>{/key}
</div>

<style>
  .countdown {
    position: fixed;
    inset: 0;
    z-index: 40;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: var(--theme-background);
    pointer-events: none;
  }
  .count-num {
    animation: var(--theme-countdown-animation);
    font-family: var(--theme-display-font);
    font-size: 140px;
    font-weight: 800;
    color: var(--theme-accent);
    line-height: 1;
  }
</style>
